import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

export interface BucketImageProps {
  location: string
  alt: string
  width: number
}

const CloudFrontUrl = 'https://dx1ad1ot0fcsp.cloudfront.net'

const BucketImage: React.FC<BucketImageProps> = ({ location, width, alt }) => {
  const options = {
    bucket: 'liquid-collectibles',
    key: location,
    edits: {
      resize: {
        width,
        fit: 'cover',
      },
    },
  }

  const imageRequest = JSON.stringify(options)

  const url = `${CloudFrontUrl}/${btoa(imageRequest)}`

  return <LazyLoadImage src={url} alt={alt} style={{ borderRadius: 6 }} />
}

export default BucketImage
